/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UmbrellaValidationRequest
 */
export interface UmbrellaValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaValidationRequest
     */
    token: string;
}

/**
 * Check if a given object implements the UmbrellaValidationRequest interface.
 */
export function instanceOfUmbrellaValidationRequest(value: object): value is UmbrellaValidationRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function UmbrellaValidationRequestFromJSON(json: any): UmbrellaValidationRequest {
    return UmbrellaValidationRequestFromJSONTyped(json, false);
}

export function UmbrellaValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaValidationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function UmbrellaValidationRequestToJSON(value?: UmbrellaValidationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

